module.exports = __webpack_public_path__ + "img/home-prize-7.d9b8b67b.png";